import IconEmail from '@apollo/icons/default/IconEmail.svg';
import IconGitHubSolid from '@apollo/icons/default/IconGitHubSolid.svg';
import IconLock from '@apollo/icons/default/IconLock.svg';
import { Button } from '@apollo/orbit';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { MaybeEmbeddedLoginLink } from 'src/app/embedHelpers/MaybeEmbedLoginLink';
import * as onboardingRoutes from 'src/app/onboarding/routes';
import { useHandleProviderSubmit } from 'src/hooks/useHandleProviderSubmit';

import { welcome } from '../../onboarding/routes';

export const SandboxSignUpButtons = ({
  iconOnly = false,
  userSegmentType = 'sandbox',
}: {
  iconOnly?: boolean;
  userSegmentType?: Parameters<typeof welcome.path>[0]['type'];
}) => {
  const location = useLocation();

  const [loggingInGithub, setLoggingInGithub] = useState<boolean>(false);

  const handleProviderSubmitGithub = useHandleProviderSubmit({
    provider: 'github',
    // GitHub signins should always redirect to the welcome page, so we don't
    // lose the referrer `type` in the query param. Passing `from` to the welcome
    // route will redirect to `from` when / if the privacy policy is signed
    callbackUrl: onboardingRoutes.welcome.path({
      from: window.location.pathname,
      location,
      type: userSegmentType,
    }),
    setLoggingIn: setLoggingInGithub,
    type: userSegmentType,
  });

  return (
    <div className="flex gap-4">
      <Button
        isLoading={loggingInGithub}
        onClick={handleProviderSubmitGithub}
        leftIcon={<IconGitHubSolid />}
      >
        {!iconOnly && 'GitHub'}
      </Button>

      <Button
        isDisabled={loggingInGithub}
        as={Link}
        to={onboardingRoutes.welcome.location({
          from: window.location.pathname,
          location,
          type: userSegmentType,
        })}
        leftIcon={<IconEmail />}
      >
        {!iconOnly && 'Email'}
      </Button>
      <Button
        isDisabled={loggingInGithub}
        as={Link}
        to={onboardingRoutes.login.location({
          from: window.location.pathname,
          location,
          type: 'sso',
        })}
        leftIcon={<IconLock />}
      >
        {!iconOnly && 'SSO'}
      </Button>
    </div>
  );
};

export const SandboxLogInButton = ({
  userSegmentType = 'sandbox',
  className,
}: {
  userSegmentType?: Parameters<typeof welcome.path>[0]['type'];
  className?: string;
}) => (
  <Button
    className={className}
    as={MaybeEmbeddedLoginLink}
    userSegmentType={userSegmentType}
  >
    Log in
  </Button>
);
